import React from 'react';
import { Money } from '../../../../../../../Money';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../../theme';
import cn from 'classnames';
const Taxes = ({ className, price }) => {
    const { t } = useTranslation('FareGroup');
    const { Taxes: css } = useTheme('Entities').FareGroupV2;
    return (React.createElement("div", { className: cn(css.root, className) },
        t('Taxes and fees'),
        ": ",
        React.createElement(Money, { money: price })));
};
export default Taxes;
